import { expected } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { ToolkitControllerGlobalContext } from '../consts.js';
import { ToolkitControllerGlobal } from '../types.ts';

export function useToolkitControllerGlobal(): ToolkitControllerGlobal;
export function useToolkitControllerGlobal(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError: boolean,
): ToolkitControllerGlobal;
export function useToolkitControllerGlobal(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError = false,
) {
  const msg = 'useToolkitControllerGlobal called outside of ToolkitController';
  const globalContext = useContext(ToolkitControllerGlobalContext);

  if (globalContext) return globalContext;

  const context = iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError ? {} : undefined;

  return expected(context, msg);
}
